<template>
  <div class="information">
    <h3 class="title">
      {{ news[id].text }}
    </h3>
    <div class="meta">
      <div class="hd">
        盖德健康
      </div>
    </div>
    <video controls class="video" :src="news[id].node" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: 0,
      news: [
        {
          images: require('../../assets/images/home/mv.png'),
          text: '01 盖德500S手环 安装及佩戴操作简介',
          node: 'http://admin.guiderhealth.com:8001/01 盖德500S手环 安装及佩戴操作简介.mp4',
          state: 1
        },
        {
          images: require('../../assets/images/home/mv.png'),
          text: '02 盖德500S手环 APP下载及安装操作简介',
          node: 'http://admin.guiderhealth.com:8001/02 盖德500S手环 APP下载及安装操作简介.mp4',
          state: 2
        },
        {
          images: require('../../assets/images/home/mv.png'),
          text: '03 盖德500S手环 APP数据查看及手环使用',
          node: 'http://admin.guiderhealth.com:8001/03 盖德500S手环 APP数据查看及手环使用.mp4',
          state: 3
        },
        {
          images: require('../../assets/images/home/mv.png'),
          text: '盖德健康500S手环 简介及操作演示（未分解演示操作）',
          node: 'http://admin.guiderhealth.com:8001/盖德健康500S手环 简介及操作演示（未分解演示操作）.mp4',
          state: 4
        },
        {
          images: require('../../assets/images/home/mv.png'),
          text: 'M500远程医疗巡诊箱 操作演示',
          node: 'http://admin.guiderhealth.com:8001/M500远程医疗巡诊箱 操作演示.mp4',
          state: 5
        }
      ]
    }
  },
  created() {
    this.id = this.$route.query.id - 2
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
    .information {
        background: #fff;
        padding: 15px;
    }
    .title {
        font-size: 18px;
        font-weight: bold;
        line-height: 1.4;
    }
    .meta {
        display: flex;
        justify-content: space-between;
        margin: 10px 0 20px;
        .bd {
            color: #999;
        }
    }
</style>
<style lang="scss">
    article {
        font-size: 15px;
        line-height: 1.6;
        img {
            max-width: 100%;
        }
        p {
            line-height: 1.8;
            margin-bottom: 10px;
        }
    }
    .video {
      width: 100%;
    }
</style>

